<template>
    <div v-if="props.selectProduct !== 'prod_partial_removable_denture'" class="preference-product-box">
        <!-- 配置表单组件 -->
        <div class="form-left">
            <xl-scrollbar height="100%" ref="scrollbarRef">
                <div class="top-form">
                    <!-- 牙齿色号 -->
                     <div v-show="props.selectProduct === 'prod_DSD'" class="dental-code">
                        <div class="dental-text">{{ $t('design.preference.dentalShadeCode') || '牙齿色号'}}</div>
                        <xl-input class="input-width" v-model="toothShadeCode" :placeholder="$t('design.preference.inputPlaceholder') || '请输入内容'">
                        </xl-input>
                    </div>
                    <!-- 模型标签 -->
                    <div v-show="props.selectProduct === 'prod_automated_simple_3d_model'" class="dental-code model-label"  @click="modelLabelFocus" :class="{'active-input': activeItemKey === 'modelLabel'}">
                        <div class="dental-text" >{{ $t('design.preference.modelLabel') || '模型标签'}}</div>
                        <xl-input class="input-width" v-model="modelLabel" :placeholder="$t('design.preference.modelLabelPlaceholder') || '请输入字母或数字'" onkeyup="value=value?.replace(/[^a-zA-Z0-9]{1,3}$/g, '')" maxlength="3">
                        </xl-input>
                    </div>
                    <!-- <dentalShadeCode v-if="showDentalShadeCode"></dentalShadeCode> -->
                    <config-form
                        ref="configFormRef"
                        @itemMouseDown="onItemClick"
                        :configList="formConfig">
                    </config-form>
                    <!-- 扫描岗组件 -->
                    <scanningRod v-show="props.showScanningRod" ref="scanningRodRef" :class="{'showBorder': props.showDashedBorder}" :selectProduct="props.selectProduct" :scanningData="scanningData" :implantSurgeryData="implantSurgeryData" @itemMouseDown="onItemClick" @changeRodDefault="changeRodDefault"></scanningRod>
                </div>
            </xl-scrollbar>
            <div class="footer">
                <xl-button @click="reset">{{ $t('design.reset') || '重置'}}</xl-button>
                <xl-button type="primary" @click="onSubmit">{{ $t('design.submit') || '提交'}}</xl-button>
            </div>
        </div>
        <!-- 配置图组件：类型+展示图 -->
        <div class="right">
            <type-index v-if="isShow" :paramsBg="activeItemKey" :currentType="props.currentType"/>
        </div>
    </div>
    <!-- 活动钢托 -->
    <div v-else class="removable-denture">
        <noData :text="$t('design.preference.removableDenture') || '请在设计需求步骤中上传设计图或备注设计要求'"></noData>
    </div>
</template>

<script setup>
import { ref, watch, defineExpose, computed, onMounted, nextTick, defineEmits } from 'vue';
import { XlButton, XlScrollbar, XlMessage, XlInput } from '@shining3d/ui-components';
import ConfigForm from './configForm.vue';
import TypeIndex from './typeIndex.vue';
import scanningRod from './scanningRod.vue';
import noData from '../../../components/no-data.vue';
import dentalShadeCode from './dentalShadeCode.vue';
import { mockFData, mockCData, mockEData, mockDData, mockAData, mockJData, mockIData, mockKData } from '../../../mock/preference.js';
import { useLang } from '@shining3d/common-module/utils/lang';
import { countDecimalPlaces } from '../../../utils/common.js';
import preferenceApi from '../../../api/preference';
import _get from 'lodash/get';
import store from '@/store';

const { $t } = useLang( '@shining3d/xl-design-order' );
const orgID = computed(() => _get( store, 'state.factorySelect.id', ''));
const props = defineProps({
    formConfigObj: {
        type: Array,
    },
    extraData: {
        type: String
    },
    selectProduct: {
        type: String
    },
    selectType: {

    },
    currentType: {
        type: String
    },
    showScanningRod: {
        type: Boolean,
        default: false
    },
    showDashedBorder: {
        type: Boolean
    },
    isShow: {
        type: String,
        default: true
    }
})
const emits = defineEmits(['getPreferenceList']);
// const currentType = ref('B');
const formConfig = ref([]);
// 当时产品tba的key
const productKey = ref('')
const scanningRodRef = ref()
// 牙齿色号
const toothShadeCode = ref('')
// 模型标签
const modelLabel = ref('');
// 扫描杆数据号
const scanningData = ref({})
// 种植导板数据
const implantSurgeryData = ref({})
const scrollbarRef = ref()
// 扫描杆是否展示
// const showScanningRod = ref(false);
// 牙齿色号是否展示
// const showDentalShadeCode = ref(true);

// formConfig.value = mockFData;
// formConfig.value = mockDData;
// formConfig.value = mockAData;
// formConfig.value = mockCData;
// formConfig.value = props.formConfigObj;
watch(() => props.selectProduct, (val) => {
    if( val) {
        formConfig.value = props.formConfigObj;
        if( !props.extraData ){
            toothShadeCode.value = '';
            modelLabel.value = '';
            scanningData.value = {};
            implantSurgeryData.value = {};
        }
    }
}, {immediate: true, deep: true});

watch(() => props.formConfigObj, (val) => {
    if( val) {
        formConfig.value = val;
    }
}, {immediate: true, deep: true});
const defaultExtraData = ref({})

watch(() => props.extraData, (val) => {
    // if( val) {
        try{
            defaultExtraData.value = val !== '' ? JSON.parse(val) : {};
            toothShadeCode.value = defaultExtraData.value?.dentalShadeCode || '';
            modelLabel.value = defaultExtraData.value?.modelLabel || '';
            scanningData.value = defaultExtraData.value?.scanningRod || {};
            implantSurgeryData.value = defaultExtraData.value?.guidedImplantSurgery || {};
        } catch( error) {
            defaultExtraData.value = {};
            toothShadeCode.value = '';
            modelLabel.value = '';
            scanningData.value = {};
            implantSurgeryData.value = {};
            console.log(error);
        }
    // }
}, {immediate: true, deep: true});

// const changeRodDefault = (val) => {
//     scanningData.value = val;
// }
const activeItemKey = ref('');
const onItemClick = ( config ) => {
    console.log( config, 'config=====')
    if( config?.preCode === 'implantCrown_gingivalThickness'){
        activeItemKey.value = config?.preCode || '';
    } else {
        activeItemKey.value = config?.key || '';
    }
};
// 模型标签点击修改activeItemKey
const modelLabelFocus = () => {
    activeItemKey.value = 'modelLabel';
}
// 是否点击的是表单内的元素
const isInFormEle = (element) =>{
    // const classNames = ['design-preference-ipt-number', 'design-preference-config-select'];
    const classNames = ['config-form', 'model-label'];
    return classNames.some(className => element.closest('.' + className) !== null);
};

window.addEventListener('click', (e) => {
    if (!isInFormEle(e.target)) {
      activeItemKey.value = '';
      console.log( activeItemKey.value, 'activeItemKey=====')
    }
});

const configFormRef = ref();
// 需要展示扫描杆的产品
const showScanningProductList = ['prod_3D_implant_model', 'prod_customized_implant_abutments', 'prod_malo_bridge', 'prod_guided_implant_surgery', 'prod_implant_crown', 'prod_implant_coping', 'prod_implant_allonx']
// 重置
const reset = () => {
    configFormRef.value?.getDefaultValue();
    forceUpdateForm();
    // 微笑形态-牙齿色号重置
    if( props.selectProduct === 'prod_DSD' ){
        toothShadeCode.value = defaultExtraData.value?.dentalShadeCode || ''
    }
    // 微笑形态-模型标签重置
    if( props.selectProduct === 'prod_automated_simple_3d_model' ){
        modelLabel.value = defaultExtraData.value?.modelLabel || ''
    }
    // 扫描杆、种植导体数据重置
    if( scanningRodRef.value && showScanningProductList.includes( props.selectProduct )){
        Object.keys(scanningRodRef.value.rodFormData)?.forEach(key => {
            scanningRodRef.value.rodFormData[key] = scanningRodRef.value.defaultData[key] || ''
        });
        // 种植导体
        if( props.selectProduct === 'prod_guided_implant_surgery'){
            Object.keys(scanningRodRef.value.guidedFormData)?.forEach(key => {
                scanningRodRef.value.guidedFormData[key] = implantSurgeryData.value[key] || ''
            });
        }
    }

    XlMessage({
		type: 'success',
		message: $t('design.preference.resetSuccess') || '重置成功'
	});

}
const onSubmit = () => {
    const content = getValue();
    
    const data = {
        orgID: orgID.value,
        productType: props.selectType,
        productConfig: props.selectProduct,
        content: JSON.stringify(content)
    }
    preferenceApi.saveProductPreference(data).then((res) => {
        if( res && res.status === 'success' ) {
            XlMessage({
				type: 'success',
				message: $t('design.preference.saveSuccess' || '保存成功')
			});
            emits('getPreferenceList');
        }
    })
};

const getValue = () => {
    let data = {};
    let preferences = [];
    let extra = '';
    const configMap =  {};
    (props.formConfigObj || []).forEach(item => {
        configMap[item.preCode] = item;
    });
    const currentValue = configFormRef.value?.getValue() || {};
    Object.keys(currentValue)?.forEach(key => {
        let preValue = currentValue[key] == undefined ? '' : currentValue[key];
        if ( configMap[key].paramApp !== 1 && configMap[key].preType === 'number' && configMap[key].preUnit !== '°' && preValue !== '') {
            try {
                if ( countDecimalPlaces(preValue) < 2) {
                    preValue = Number(preValue).toFixed(2);
                }
            } catch(e) {
                console.log(e)
            }
        }
        preferences.push({
            preCode: key,
            preValue: String(preValue),
            paramApp: configMap[key].paramApp
        })
    });
    //扫描杆
    if( showScanningProductList.includes( props.selectProduct ) ){
        if( scanningRodRef.value ){
            if( scanningRodRef.value.rodFormData?.company ){
                extra = {
                    ...extra,
                    scanningRod: scanningRodRef.value.rodFormData,
                    systemID: scanningRodRef.value.selectModelID
                }
            }
            // 种植导体
            if( props.selectProduct === 'prod_guided_implant_surgery' && ( scanningRodRef.value.guidedFormData?.toolboxBrand || scanningRodRef.value.guidedFormData?.toolboxSeries )){
                extra = {
                    ...extra,
                    guidedImplantSurgery: scanningRodRef.value.guidedFormData
                }
            }
        }
    }
    // 微笑设计
    if( props.selectProduct === 'prod_DSD'){
        extra = {
            ...extra,
            dentalShadeCode: toothShadeCode.value
        }
    } else  if( props.selectProduct === 'prod_automated_simple_3d_model'){
        // 自动化设计3D模型-模型标签
        extra = {
            ...extra,
            modelLabel: modelLabel.value
        }
    }
    data = {
        isExtra: true,
        extra: extra ? JSON.stringify(extra) : '',
        preferences: preferences
    }
    // data = configFormRef.value.getValue();
    return data;
};

// 判断当前组件的值是否修改
const changeParamsValue = () => {
    let flag = false;
    if( configFormRef.value ){
        const paramsObj = configFormRef.value.getValue() || {};
        formConfig.value.forEach((item) => {
            if (paramsObj?.[item.preCode]) {
                let defaultValue = item.preValue;
                let formItemValute = paramsObj[item.preCode];
                // input类型的时候，全部转换为number类型进行值的比较
                if ( item.preType === 'number' ) {
                    defaultValue = Number(defaultValue);
                    formItemValute = Number(formItemValute);
                }
                if ( formItemValute != defaultValue ) {
                    flag = true;
                }
            }
        })
    }
    // 微笑设计-牙齿色号值是否发生变化
    if( props.selectProduct === 'prod_DSD' && toothShadeCode.value !== (defaultExtraData.value?.dentalShadeCode || '') ) {
        flag = true;
    }
    // 自动化设计3D模型-模型标签值是否发生变化
    if( props.selectProduct === 'prod_automated_simple_3d_model' && modelLabel.value !== (defaultExtraData.value?.modelLabel || '') ) {
        flag = true;
    }
     //扫描杆
    if( scanningRodRef.value && showScanningProductList.includes( props.selectProduct )){
        // Object.keys(scanningRodRef.value.rodFormData)?.forEach(key => {
        //     console.log( scanningData.value, scanningRodRef.value.rodFormData ,'=======')
        //     if( (scanningData.value[key] || '') !== scanningRodRef.value.rodFormData[key] ){
        //         flag = true;
        //     }
        // });
        flag = scanningRodRef.value.changeData();
        // 种植导体
        if( props.selectProduct === 'prod_guided_implant_surgery'){
            Object.keys(scanningRodRef.value.guidedFormData)?.forEach(key => {
                if( (implantSurgeryData.value[key] || '') !== scanningRodRef.value.guidedFormData[key] ){
                    flag = true;
                }
            });
        }
    }
    return flag;
}

watch(() => props.selectProduct, (val) => {
    // 微笑设计-若有默认值，传的key为默认值
    if( val === 'prod_DSD' ){
        const smileObj = formConfig.value.find((item) => item.preCode === 'DSD_smileLibrarySelection')
        activeItemKey.value = smileObj?.preValue || '';
    }
    nextTick(() => {
        scrollbarRef.value?.setScrollTop(0);
    })
}, {immediate: true})

watch(() => props.isShow, (val) => {
    // 微笑设计-若有默认值，传的key为默认值
    if( val && props.selectProduct === 'prod_DSD' ){
        nextTick(() => {
            const obj = configFormRef.value?.getValue() || {};
            activeItemKey.value = obj['DSD_smileLibrarySelection'] || '';
        });
    }
}, { immediate: true });

const forceUpdateForm = () => {
    configFormRef.value.forceUpdate();
};  

defineExpose({ getValue, changeParamsValue, forceUpdateForm });

</script>

<style lang="scss" scoped>
.preference-product-box{
    height: calc( 100vh - 210px );
    box-sizing: border-box;
    // background: #FFFFFF;
    display: flex;

    .form-left {
        width: 402px;
        min-width: 402px;
        background: #fff;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        margin-right: 16px;
        display: flex;
        justify-content: center;
        padding-top: 16px;
        flex-direction: column;
        .top-form {
            padding-left: 16px;
            flex: 1;
            .dental-code{
                display: flex;
                align-items: center;
                margin-bottom: 18px;
                .dental-text{
                    width: 166px;
                    box-sizing: border-box;
                    padding-right: 12px;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 22px;
                    color: #42526E;
                }
                .input-width{
                    width: 204px;
                }
            }
            .model-label{
                margin-bottom: 12px !important;           
            }
            .active-input{
                :deep(.el-input__inner){
                    box-shadow: 0 0 0 2px var(--el-input-focus-border-color, var(--el-color-primary)) inset !important;
                }
            }
            // overflow-y: auto;
        }
        .el-form {
            .el-form-item {
                margin-bottom: 16px;
            }
        }

        .footer {
            height: 68px;
            display: flex;
            align-items: center;
            justify-content: center;    
            border-top: 1px solid #E0E4EA;
        }
        .showBorder{
            margin-top: 16px;
            padding-top: 16px;
            border-top: 1px dashed #E0E4EA;
        }
    }

    .right {
        flex: 1;
        width: 100%;
        height: 100%;
        // box-sizing: border-box;
        background: #fff;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        padding: 16px;
    }
    :deep(.el-scrollbar__view){
        // height: 100%;
        display: flex;
        flex-flow: column;
    }
}
.removable-denture{
    height: calc( 100vh - 210px );
    background: #FFFFFF;
    border-radius: 10px 10px 0 0;
    :deep(.no-data-outer){
        display: flex;
        align-items: center;
        justify-content: center;
        .no-data-body{
            position: static;
            transform: translate(0) !important;
        }
        
    }
}
.case-design-preference {
    background: transparent !important;
}
</style>